import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { Store, select } from '@ngrx/store';
import * as selectorsRelationship from '../../../../root-store/relationship-store/relationship.selector';
import { UntypedFormControl } from '@angular/forms';

import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { RootStoreState } from '@app/root-store';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '@app/shared/services';
import { EVENTS } from '@app/constants/events.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { getWorkspaceItem } from '@app/root-store/workspaces-store/selector';
import { fetchUserAttributes } from '@aws-amplify/auth';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'vault-setup-members',
  templateUrl: './vault-setup-members.component.html',
  styleUrl: './vault-setup-members.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultSetupMembersComponent implements OnInit, OnDestroy {
  @Input() personalVaultName;
  @Input() stateObject: any = {};
  @Input() userObject: any = {};
  @Input() isFromVault = false;
  @Input() isFromManageVault = false;
  @Input() vaultMembers = [];
  @Input() selectedVaultType;
  @Input() professionalVaultCreator;
  @Input() vaultName = '';

  allowed_change_owner = false;
  @Input() make_owner_enabled = false;
  @Output() setVaultMember = new EventEmitter();
  connectionUserFormControl = new UntypedFormControl();
  switchFromUser: boolean = false;
  isLoading = false;

  isShowFooter = true;
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  options = [
    {
      value: 'Yes',
      isSelected: false,
    },
    {
      value: 'No',
      isSelected: false,
    },
  ];

  allUserConnections = [];
  selectedMember;
  routeId;
  nonProfessionalUsers = [];

  constructor(
    private cd: ChangeDetectorRef,
    private store: Store,
    private route: ActivatedRoute,
    private sharedVaultService: SharedVaultService,
    private store$: Store<RootStoreState.State>,
    private _userService: UserService,
    private _router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.professionalVaultCreator) {
      if (this.professionalVaultCreator?.user_first_name || this.professionalVaultCreator?.user_last_name) {
        this.selectedMember = {
          ...this.professionalVaultCreator,
          profile_image_url: this.professionalVaultCreator?.user_profile_image_url,
          name: this.professionalVaultCreator?.user_first_name + ' ' + this.professionalVaultCreator?.user_last_name,
        };
      } else {
        this.selectedMember = this.professionalVaultCreator;
      }
    } else {
      this.subscription.add(
        this.store.select(loginSelectors.getCurrentUserFullDetails).subscribe((data) => {
          this.selectedMember = data;
        })
      );
    }
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.subscription.add(
      this.store$.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          if (result) {
            this.personalVaultName = result.nick_name;
            this.switchFromUser = true;
          }
          const authUser = await await fetchUserAttributes();
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.switchFromUser = true;
          } else {
            this.switchFromUser = false;
          }
        } catch (ex) {}
      })
    );

    if (!this.isFromVault) {
      this.isLoading = true;
      this.getInitialData();
    } else {
      this.nonProfessionalUsers = this.vaultMembers;
    }
    if (this._router.url.includes('/workspace/')) {
      this.isShowFooter = false;
      const split_url = this._router.url.split('/');
      this.routeId = split_url[2];
      this.subscription.add(
        this.store.select(getWorkspaceItem(this.routeId)).subscribe((data) => {
          this.allUserConnections = data.members.filter((x) => x.status == 'accept' && x.type == 'family').map((x) => ({ ...x, ...x.userDetails }));
          this.allUserConnections = this.allUserConnections.filter((d) => d.id !== this.selectedMember.id);
        })
      );
    } else {
      this.getMemberData();
    }
  }

  getMemberData() {
    this.subscription.add(
      this.store.select(selectorsRelationship.getAndFilterAllUsersExcludeExstingUser('', [])).subscribe((data) => {
        let updatedObject = [];
        data.forEach((element, index) => {
          let tempEllemt = {
            ...element,
            name: '',
          };
          tempEllemt.id = element?.user_id;
          tempEllemt.name = element?.user_first_name + ' ' + element?.user_last_name;
          updatedObject.push(tempEllemt);
        });
        this.allUserConnections = [
          ...updatedObject.map(({ id, user_id, name, relationship_name, user_profile_image_url, user_first_name, user_last_name }) => ({
            id,
            user_id,
            name,
            relationship_name,
            user_profile_image_url,
            key: ConfigurationType.USERS,
            user_first_name,
            user_last_name,
          })),
        ];
        this.allUserConnections = this.allUserConnections.filter((d) => d.id !== this.selectedMember.id);
      })
    );
  }

  updateMember(user) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Change Owner',
        materialIcon: 'info',
        text: `Are you sure you want to make ${user.memberUser.first_name + ' ' + user.memberUser.last_name} the owner of ${
          this.vaultName
        }? Doing this will remove you as the owner.`,
        proceedTitle: 'Continue',
        showCancelBtn: true,
      },
      disableClose: false,
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let model = {
            vault_id: this.stateObject?.id ? this.stateObject?.id : null,
            owner_id: user.user_id,
          };
          this.subscription.add(
            this.sharedVaultService.updateVaultOwner(model).subscribe((data) => {
              if (data) {
                this.getInitialData();
                this.cd.detectChanges();
              }
            })
          );
        }
      })
    );
  }
  getInitialData() {
    this.subscription.add(
      this.sharedVaultService.getVaultMembers(this.userObject.id, this.stateObject?.id).subscribe((data) => {
        this.subscription.add(
          this.store.select(selectorsRelationship.getrelationshipnameList(data)).subscribe((item) => {
            this.nonProfessionalUsers = item.map((element: any) => ({
              ...element,
              relationship_name: element.user_id === this.userObject?.id ? 'You' : element.relationship_name ? element.relationship_name : null,
            }));
            if (this.nonProfessionalUsers.find((user) => user.type === 'owner')?.user_id == this.selectedMember.id && this.make_owner_enabled) {
              this.allowed_change_owner = true;
            } else {
              this.allowed_change_owner = false;
            }
            this.isLoading = false;
            this.cd.markForCheck();
          })
        );
      })
    );
  }

  selectConnectedUser(user) {
    this.connectionUserFormControl.disable();
    const updateUser = {
      ...user,
      first_name: user.user_first_middle_name,
      last_name: user.user_last_name,
      profile_image_url: user.user_profile_image_url,
      user_first_name: user.user_first_name
        ? user.user_first_name
        : user.first_middle_name
        ? user.first_middle_name
        : (user.name || '').split(' ') && (user.name || '').split(' ').length
        ? (user.name || '').split(' ')[0]
        : '',
    };

    const memberUser = {
      id: user.id ? user.id : user.user_id,
      user_id: user.id ? user.id : user.user_id,
      from_user_id: user.from_user_id,
      connection_status: user.connection_status,
      relationship_name: user.relationship_name,
      user_first_name: user.user_first_name
        ? user.user_first_name
        : user.first_middle_name
        ? user.first_middle_name
        : (user.name || '').split(' ') && (user.name || '').split(' ').length
        ? (user.name || '').split(' ')[0]
        : '',
      memberUser: updateUser,
    };

    if (this.isFromVault) {
      this.nonProfessionalUsers = [...this.nonProfessionalUsers, memberUser];
      this.setVaultMember.emit(this.nonProfessionalUsers);
      this.cd.detectChanges();
    } else {
      let model = {
        vault_id: this.stateObject?.id ? this.stateObject?.id : null,
        user_id: user.id ? user.id : user.user_id,
      };
      this.subscription.add(
        this.sharedVaultService.createVaultMember(model).subscribe((data) => {
          if (data) {
            this.nonProfessionalUsers = [...this.nonProfessionalUsers, memberUser];
            this.connectionUserFormControl.enable();
            this.getInitialData();
            this.trackEventsInMixPanel('add');
            this.cd.markForCheck();
          }
        })
      );
    }
  }

  deleteMember(user) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this member?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (this.isFromVault) {
            this.nonProfessionalUsers = this.nonProfessionalUsers.filter((item) => item.id != user.id);
            this.setVaultMember.emit(this.nonProfessionalUsers);
            this.cd.detectChanges();
          } else {
            let model = {
              id: user.id ? user.id : '',
              user_id: user.user_id ? user.user_id : user.memberUser.id,
            };
            this.subscription.add(
              this.sharedVaultService.deleteVaultMember(model.user_id, model.id).subscribe((data) => {
                if (data) {
                  this.nonProfessionalUsers = this.nonProfessionalUsers.filter((item) => item.id != user.id);
                  this.trackEventsInMixPanel('remove');
                  this.cd.markForCheck();
                }
              })
            );
          }
        }
      })
    );
  }

  handleSubFlow(response: string, flow: any) {
    this.options.forEach((opt) => {
      opt.isSelected = opt.value === response;
    });
    // this.discoveryData.answer = response;

    this.cd.detectChanges();
  }

  trackEventsInMixPanel(actionType) {
    const events =
      this.selectedVaultType === 'personal_vault'
        ? [{ eventName: EVENTS[`personal_vault_setup_${actionType}_member_change`] }]
        : this.selectedVaultType === 'shared_vaults'
        ? [{ eventName: EVENTS[`shared_vault_setup_${actionType}_member_change`] }]
        : this.selectedVaultType === 'entity_vault'
        ? [{ eventName: EVENTS[`entity_vault_setup_${actionType}_member_change`] }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
